import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { Link } from 'react-router-dom';
import { Colors } from '@lean-body/components/styles';
import { routes } from '@lean-body/src/route';
import { BellIcon } from '../atoms/icons/bell_icon';
export const HeaderRightItems = ({ unreadAnnouncementCount }) => {
    return (React.createElement("div", { className: css(styles.rightItems) },
        React.createElement(Link, { to: routes.ANNOUNCEMENT_LIST.compile() },
            React.createElement(BellIcon, { hasBadge: unreadAnnouncementCount === null || unreadAnnouncementCount === void 0 ? void 0 : unreadAnnouncementCount.moreThanZero, classObject: styles.bell }))));
};
const styles = StyleSheet.create({
    rightItems: {
        display: 'flex',
        alignItems: 'center',
        position: 'absolute',
        right: 16,
    },
    chatContainer: {
        position: 'relative',
    },
    coachingMessage: {
        fontSize: 8,
        fontWeight: 'bold',
        color: Colors.White,
        backgroundColor: Colors.Accent,
        padding: '1.8px 3px 1px',
        position: 'absolute',
        top: 0,
        right: 7,
        borderRadius: 100,
        lineHeight: 1,
    },
    chat: {
        marginRight: 20,
    },
    bell: {
        width: 22,
        height: 23,
    },
});
